import withInputFields from "../../helpers/inputfields";
import withReactiveFields from "../../helpers/reactivefields";
import { isPlainObject, getValueAtPath, withProperties, isBoolean } from "../../../../utils";
import withSavedCards, { selectSavedCardsFromList } from "../../../../collections/savedcards";
import { USES_CHARGE_POLLING, USES_CHARGE_VALIDATE, USES_VALIDATE_POLLING } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";

import InitView from "./views/init";
import PaymobInitView from "./views/initpaymob";
import AuthView from "./views/auth";
import ValidateView from "./views/otp";
import RegisterMobileView from "./views/registermobile";
import RedirectView from "../../common/redirect";
import { isoCountryOptions, selectIsoCountryFromList } from "../../../../collections/isocountries";
import getCardType from "../../../../collections/cardtypes";
import getCardDiscount from "../../../../collections/carddiscount";
import CampaignState from "../../../common/campaign";

const METHOD = 'card';
const METHOD_NAME = 'Card';
const CHARGE_MODE = USES_CHARGE_POLLING | USES_CHARGE_VALIDATE | USES_VALIDATE_POLLING;

const VIEWS = [ InitView, AuthView, PaymobInitView, RegisterMobileView, ValidateView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the form (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const currency = getValueAtPath(this.STATE, 'currency.current')
      const canSwitchToPaymob = getValueAtPath(this.DATA, 'preferences[can_switch_to_paymob]') === true;

      const VIEW = (
        this.REDIRECT_URL && (RedirectView || this.$resetContext())
      ) || (
        this.SHOULD_VALIDATE_CHARGE && (ValidateView || this.$resetContext())
      ) || (
        this.COLLECT_MOBILE_INSTRUCTIONS && (RegisterMobileView || this.$resetContext())
      ) || (
        this.authModel && (AuthView || this.$resetContext())
      ) || (
        currency === 'EGP' && canSwitchToPaymob && PaymobInitView || InitView
      );

      VIEW && VIEW.activate.call(this, () => {
        VIEW === InitView && this.$savedCards.fetch();
      });

    });
  
    getChargeFee();
  };
}

function getChargeData() {
  if (this.SHOULD_VALIDATE_CHARGE) return;
  const currency = getValueAtPath(this.STATE, 'currency.current');
  const canSwitchToPaymob = getValueAtPath(this.DATA, 'preferences[can_switch_to_paymob]') === true;

  return ({
    include_card_country: true,
    payment_type: currency === 'EGP' && canSwitchToPaymob  ? 'paymob' : 'card'
  });
}

function getViewsContext(data, store) {
  let resendTimer;
  const currency = getValueAtPath(data, 'currency');
  const canSwitchToPaymob = getValueAtPath(data, 'preferences[can_switch_to_paymob]') === true;

  const REACTIVE_FIELDS = [
    'CAN_RESEND_OTP',
    'REDIRECT_URL',
    'SAVED_CARDS',
    'SAVED_CARDS_ACTIVE',
    'SAVED_CARDS_AVAILABLE',
    'SHOULD_VALIDATE_CHARGE',
    'COLLECT_MOBILE_INSTRUCTIONS',
    'CARD_TYPE'
  ];

  const $context = withProperties(Object.create(null), {
    useOldSavedCardFlow: getValueAtPath(data, 'preferences[use_old_saved_card_flow]') === true,

    $resetContext() {
      $context.REDIRECT_URL =  $context.SHOULD_VALIDATE_CHARGE = $context.COLLECT_MOBILE_INSTRUCTIONS = $context.authModel = $context.CARD_TYPE = null;
      $context.$inputs.$reset();
    },

    INIT_VIEW: callback => {
      currency === 'EGP' && canSwitchToPaymob 
        ? PaymobInitView && PaymobInitView.activate(callback)
        : InitView && (
          $context.$resetContext(),
          InitView.activate(callback)
        );
    },
    
    clearResendTimer: () => {
      resendTimer && clearTimeout(resendTimer);
      resendTimer = null;
      $context.CAN_RESEND_OTP = false;
    },

    startResendTimer: () => {
      $context.clearResendTimer();
      resendTimer = setTimeout(() => ($context.CAN_RESEND_OTP = true), 90 * 1000);
    },

  });

  withReactiveFields($context, ...REACTIVE_FIELDS);

  withSavedCards($context, () => {
    $context.SAVED_CARDS_ACTIVE = false;
    $context.SAVED_CARDS_AVAILABLE = false;

    function __update__() {
      $context.SAVED_CARDS_AVAILABLE = !!(
        $context.$savedCards.enabled &&
        $context.SAVED_CARDS &&
        $context.SAVED_CARDS.length > 0
      );

      !$context.SAVED_CARDS_AVAILABLE && ($context.SAVED_CARDS_ACTIVE = false);
    }

    $context.$savedCards.$subscribe((currentValue, oldValue) => {
      if (currentValue !== oldValue) {
        $context.SAVED_CARDS = currentValue;
        __update__();
      }
    });
  });

  withInputFields($context, {
    otp: null,
    pin: __authInput__(true),
    billing_address: __authInput__(),
    billing_city: __authInput__(),
    billing_country: __authInput__(false, {
      options: isoCountryOptions,
      selector: selectIsoCountryFromList.bind($context, isoCountryOptions)
    }),
    billing_state: __authInput__(),
    billing_zip: __authInput__(),
    card_holder_name: __authInputAVS__(),
    phonenumber: __authInputAVS__(),
    card_number: __input__(),
    expiry: __input__(),
    cvv: __input__(),
    remember_card: __input__({ defaultValue: false, required: false }),
    remember_email: __input__(2, getValueAtPath(data, 'email') || null),
    remember_phone: __input__(2, getValueAtPath(data, 'phone') || null),
    saved_card: __input__(1, {
      get options() { return $context.SAVED_CARDS },
      get selector() { return selectSavedCardsFromList.bind($context, this.options) }
    })
  });

  $context.resetCardType = () => {
    $context.CARD_TYPE = null;
  }

  $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
        RedirectView && RedirectView.activate.call($context);
      }
    }, 0);
  });

  $context.$subscribe('SHOULD_VALIDATE_CHARGE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue === true) {
        ValidateView && ValidateView.activate();
        $context.startResendTimer();
      }
    }, 0);
  });

  $context.$subscribe('SAVED_CARDS_ACTIVE', (currentValue, oldValue) => {
    if (oldValue !== currentValue && isBoolean(currentValue)) {
      $context.$inputs.$refresh('saved_card');
    }
  });

  $context.$inputs.$subscribe('saved_card', (currentValue, oldValue) => {
    setTimeout(() => {
      if (oldValue !== currentValue) {
        __getCardFee__(getValueAtPath(currentValue, '[value].masked_pan'));
      }
    }, 0);
  });

  $context.$inputs.$subscribe('card_number', (currentValue, oldValue) => {
    setTimeout(() => {
      if (oldValue !== currentValue) {
        __getCardFee__(getValueAtPath(currentValue, '[value]'));
      }
    }, 0);
  });

  return $context;

  function __input__(baseObject, flag) {
    if (Number.isInteger(baseObject)) {
      [baseObject, flag] = [flag, baseObject];
    }

    flag = +flag || 0;
    baseObject = isPlainObject(baseObject) ? baseObject : { defaultValue: baseObject };

    if (baseObject['defaultValue'] == undefined) {
      baseObject['defaultValue'] = null;
    }

    baseObject['available'] = function __availability__() {
      let available = true;
      const savedCardActive = $context.SAVED_CARDS_ACTIVE;

      available = available && !!(
        flag & 1
          ? savedCardActive
          : !savedCardActive && !!(
            flag & 2 ? getValueAtPath($context.$inputs, '[remember_card].value') : true
          )
      );

      return available;
    };

    return baseObject;
  }

  function __authInput__(pinAuth = false, baseObject) {
    baseObject = baseObject && isPlainObject(baseObject) ? baseObject : { defaultValue: baseObject };

    if (baseObject['defaultValue'] == undefined) {
      baseObject['defaultValue'] = null;
    }

    baseObject['available'] = function __availability__() {
      let available = true;
      
      const { auth } = isPlainObject($context.authModel) ? $context.authModel : {};
      available = auth === (pinAuth === true ? 'PIN' : 'AVS');
      if (currency === 'EGP') {
        available = true;
      } 

      return available;
    }
    return baseObject;
  }

  function __authInputAVS__(baseObject) {
    baseObject = baseObject && isPlainObject(baseObject) ? baseObject : { defaultValue: baseObject };

    if (baseObject['defaultValue'] == undefined) {
      baseObject['defaultValue'] = null;
    }

    baseObject['available'] = function __availability__() {
      let available = false;
      const { auth } = isPlainObject($context.authModel) ? $context.authModel : {};
      if (currency === 'EGP' || auth === 'AVS') {
        available = true;
      } 
      return available;
    }
    return baseObject;
  }

  function __getCardFee__(cardnumber) {
    if (cardnumber === '') {
      $context.dispatch(CampaignState.actions.updateCampaign({}));
      getChargeFee();
    }
    if (cardnumber && (cardnumber = cardnumber.replace(/\s+/g, '')) && /^\d{6}/.test(cardnumber)) {
      getCardType($context, cardnumber.slice(0, 6)).then(response => {
        $context.CARD_TYPE = response ? response.card_type : null;
        
        //if card type is mastercard, call getCardDiscount
        if (response && response.card_type && response.card_type.toLowerCase() === 'mastercard') {
          getCardDiscount($context, cardnumber.slice(0, 6)).then(() => {
            getChargeFee(cardnumber.slice(0, 6));
          })
        } else {
          $context.dispatch(CampaignState.actions.updateCampaign({}));
          getChargeFee(cardnumber.slice(0, 6));
        }
      });
    }
  }
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
